import ErrorOutlineIcon from '@mui/icons-material/ErrorOutlined'
import LockOutlinedIcon from '@mui/icons-material/LockOutlined'
import RefreshIcon from '@mui/icons-material/Refresh'
import { TextField } from '@mui/material'
import React from 'react'
import KarteraAdminTemplate from '../../../template/KarteraAdminTemplate'
import KarteraPageHeader from '../../../template/kartera/KarteraPageHeader'
import { CheckIcon } from '../../../template/kartera/icons'
import MyAccountPassword from '../password/my-account-password'
import { useMyAccountFormModel } from './my-account-form-model'

const MyAccountForm = () => {
    const model = useMyAccountFormModel()
    const { form, change } = model
    const lockedHint = model.nameLocked ? 'El usuario principal no puede cambiar su nombre.' : undefined

    return (
        <KarteraAdminTemplate loading={false} title="Mi cuenta">
            <MyAccountPassword open={model.passwordOpen} onClose={model.closePassword} onChanged={model.passwordChanged} />

            <form onSubmit={model.save} className="relative mx-auto flex w-full max-w-[880px] flex-col gap-[18px]">
                {model.busy && (
                    <div className="absolute inset-0 z-40 flex items-start justify-center rounded-2xl bg-k-bg/80 pt-24" role="status">
                        <div className="flex flex-col items-center gap-3 rounded-2xl border border-k-line bg-k-surface px-8 py-6 shadow-k-pop">
                            <RefreshIcon className="animate-spin text-brand-indigo" />
                            <p className="m-0 text-sm font-semibold text-k-ink">{model.busyLabel}</p>
                        </div>
                    </div>
                )}

                <KarteraPageHeader
                    title="Mi cuenta"
                    description="Actualiza tus datos personales y la contraseña con la que entras a Kartera."
                    backTo={model.backTo}
                    backLabel="Configuración"
                    actions={(
                        <button
                            type="button"
                            disabled={model.loading}
                            className="inline-flex h-10 items-center gap-2 rounded-xl border border-k-line bg-k-surface px-4 text-sm font-semibold text-k-ink hover:bg-k-hover disabled:cursor-not-allowed disabled:opacity-40"
                            onClick={model.openPassword}
                        >
                            <LockOutlinedIcon style={{ fontSize: 18 }} />
                            Cambiar contraseña
                        </button>
                    )}
                />

                {model.message && (
                    <div className={`flex items-center gap-3 rounded-[14px] px-4 py-3.5 text-sm ${model.message.type === 'error' ? 'bg-k-danger-soft text-k-danger-ink' : 'bg-k-ok-soft text-k-ok'}`}>
                        <ErrorOutlineIcon style={{ fontSize: 20 }} />
                        <p className="m-0">{model.message.message}</p>
                    </div>
                )}

                <section className="k-card">
                    <div className="flex items-center gap-4">
                        <span className="flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-[linear-gradient(135deg,#3E6BE6,#8B3FC9_55%,#EC3B6C)] text-lg font-extrabold text-white">
                            {model.initials}
                        </span>
                        <div className="flex min-w-0 flex-col gap-0.5">
                            <span className="truncate text-base font-bold text-k-ink">{model.fullName}</span>
                            <span className="truncate text-sm text-k-muted">{form.correo || '—'}</span>
                            {form.principal && (
                                <span className="mt-1 self-start rounded-full bg-k-accent-soft px-2 py-0.5 text-xs font-bold text-k-accent-ink">Usuario principal</span>
                            )}
                        </div>
                    </div>
                </section>

                <section className="k-card">
                    <h2 className="k-card-title">Datos personales</h2>
                    <div className="grid grid-cols-1 items-start gap-x-6 gap-y-5 md:grid-cols-3">
                        <TextField className="v2-field" variant="filled" fullWidth required disabled={model.nameLocked} label="Nombre(s)" helperText={lockedHint} value={form.nombres} onChange={(event) => change.nombres(event.target.value)} />
                        <TextField className="v2-field" variant="filled" fullWidth required disabled={model.nameLocked} label="Apellido paterno" value={form.apPat} onChange={(event) => change.apPat(event.target.value)} />
                        <TextField className="v2-field" variant="filled" fullWidth disabled={model.nameLocked} label="Apellido materno" value={form.apMat} onChange={(event) => change.apMat(event.target.value)} />
                    </div>
                </section>

                <section className="k-card">
                    <h2 className="k-card-title">Localización</h2>
                    <div className="grid grid-cols-1 items-start gap-x-6 gap-y-5 md:grid-cols-3">
                        <TextField
                            className="v2-field md:col-span-2" variant="filled" fullWidth
                            disabled
                            type="email"
                            label="Correo"
                            helperText="Es tu usuario para iniciar sesión; no se puede cambiar."
                            value={form.correo}
                        />
                        <TextField
                            className="v2-field" variant="filled" fullWidth
                            label="Celular"
                            helperText="10 dígitos."
                            value={form.celular}
                            onChange={(event) => change.celular(event.target.value)}
                            slotProps={{ htmlInput: { inputMode: 'numeric' } }}
                        />
                    </div>
                </section>

                <div className="flex flex-wrap items-center justify-end gap-2.5 pt-1">
                    <button
                        type="button"
                        className="inline-flex h-11 items-center gap-2 rounded-xl border border-k-line bg-k-surface px-4 text-sm font-semibold text-k-ink hover:bg-k-hover"
                        onClick={model.cancel}
                    >
                        Cancelar
                    </button>
                    <button
                        type="submit"
                        disabled={model.busy || !form.id}
                        className="inline-flex h-11 items-center gap-2 rounded-xl bg-k-primary px-[18px] text-sm font-bold !text-white hover:brightness-105 disabled:cursor-not-allowed disabled:opacity-40"
                    >
                        <CheckIcon />
                        Guardar cambios
                    </button>
                </div>
            </form>
        </KarteraAdminTemplate>
    )
}

export default MyAccountForm
